export default "__VITE_ASSET__CyrG$4$b__"